import { forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/i18n/i18n";
import { GlossPiece } from "@/components/conjugation/GlossPiece";

const FINGER = "text-[10px] uppercase tracking-widest font-bold";

/** Oración four-finger: tiempo + pronombre + verbo (el espacio) + información. */
export const SentencePrompt = forwardRef(({ sentence, gloss, hint, hardMode, value, onChange,
                                            pronoun, onPronoun, disabled, onEnter, onHelp }, ref) => {
  const { t } = useI18n();
  const box = "inline-flex w-auto min-w-[8rem] text-center text-lg font-semibold bg-white " +
              "border-b-2 border-orange-300 rounded-none px-2 py-1 focus-visible:ring-0 " +
              "focus-visible:border-orange-500";

  return (
    <div className="mb-2" data-testid="sentence-prompt">
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-3 text-lg leading-relaxed text-slate-800">
        <GlossPiece gloss={gloss?.marker} text={sentence.marker} onUse={onHelp}
                    testId="gloss-marker" className="text-sky-700 font-medium" />
        {sentence.subject && (
          <GlossPiece gloss={gloss?.subject} text={sentence.subject} onUse={onHelp}
                      testId="gloss-subject" className="text-violet-700 font-medium" />
        )}
        {sentence.two_blanks && (
          <Input value={pronoun} disabled={disabled} onChange={(e) => onPronoun(e.target.value)}
                 onKeyDown={(e) => { if (e.key === "Enter") onEnter(); }}
                 className={`${box} min-w-[5rem]`} placeholder={t("cj_pronoun_blank")}
                 data-testid="sentence-pronoun-input" />
        )}
        <Input ref={ref} value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}
               onKeyDown={(e) => { if (e.key === "Enter") onEnter(); }}
               className={box} placeholder={t("cj_verb_blank")}
               data-testid="practice-input" />
        <span className="text-slate-700">
          <GlossPiece gloss={gloss?.info} text={sentence.info} onUse={onHelp}
                      testId="gloss-info" />.
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-4 text-slate-500">
        <span className={`${FINGER} text-orange-600 bg-orange-50 border border-orange-200 rounded px-2 py-1`}
              data-testid="sentence-hint">
          {hardMode ? hint : `${hint}`}
        </span>
        {sentence.person_note && (
          <span className={`${FINGER} text-violet-600 bg-violet-50 border border-violet-200 rounded px-2 py-1`}>
            {sentence.person_note}
          </span>
        )}
      </div>
    </div>
  );
});
